<script setup lang="ts">
import type { ToastMessageOptions } from 'primevue/toast'

const { LocalConfigurationStore } = stores()
const toast = useToast()

const notifications: ComputedRef<(ToastMessageOptions & { key: number })[]> = computed(
  () =>
    LocalConfigurationStore.value?.brokerContext?.notifications?.map((n, i) => ({
      key: i,
      group: 'notifications',
      summary: LocalConfigurationStore.value?.brokerContext?.context.brokerName,
      detail: {
        text: n,
        close: () => toast.remove(notifications.value.find((n) => n.key === i) ?? {}),
      },
      closable: false,
    })) ?? []
)

onMounted(() => {
  notifications.value?.forEach((n) => {
    toast.add(n)
  })
})
</script>

<template>
  <PvToast
    group="notifications"
    class="z-[9999] w-[calc(100vw-2rem)]"
    position="bottom-center"
    style="position: fixed; bottom: 0px; left: 50%"
  >
    <template #message="slotProps">
      <div
        class="flex md:items-center md:flex-row justify-between gap-4 w-full flex-col items-start"
      >
        <div>
          <div class="font-bold">{{ slotProps.message.summary }}</div>
          <div class="font-medium">{{ slotProps.message.detail.text }}</div>
        </div>
        <PvButton
          size="small"
          label="Aceptar"
          class="min-w-20 w-full md:w-auto"
          @click="slotProps.message.detail.close()"
        />
      </div>
    </template>
  </PvToast>
</template>
